import {
  forwardRef,
  memo,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import "./NewPhotos.css";
import useApiHttp from "../../hooks/use-http";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import decryptUrl from "../../util/img-decryption";
import {
  Box,
  Checkbox,
  FormControlLabel,
  ImageList,
  ImageListItem,
  Skeleton,
  Stack,
  Tooltip,
} from "@mui/material";
import {
  ActionButton,
  Button,
  Container,
  Selectors,
  Text,
  DropdownMenuGroup,
  DropdownMenuItem,
  Notifications,
  AvatarV2,
  Spinner,
  InputCheckbox,
  Icon,
  DropdownMenu,
  BadgeV2,
} from "@jds/core";
import PageLoader from "../../components/UI/Loader/PageLoader";
import Loader from "../../components/UI/Loader/Loader";
import JdsMenu from "../../components/UI/JdsMenu";
import { Menu } from "../../assets/svg/svg";
import brokenImg from "../../assets/png/brokenImg.png";
import uploadPhotos from "../../assets/png/uploadPhotos.webp";
import { FileUploadContext } from "../../components/Layout/FileUploadLayout";
import {
  addParamsURL,
  bytesToHumanReadable,
  capitalizeWords,
  getArrtoDate,
  replaceMultipleSpaces,
} from "../../util/helper";
import EmptyState from "../../components/NoData/EmptyState";
import FsLightbox from "fslightbox-react";
import { useDispatch, useSelector } from "react-redux";
import { Virtuoso, VirtuosoGrid } from "react-virtuoso";
import { LazyLoadImage } from "react-lazy-load-image-component";
import JdsModal from "../../components/UI/JdsModal";
import { setReindexAlertModalClose } from "../../store/state-slices/plans";
import { NewFileUploadContext } from "../../components/Layout/NewFileUploadLayout/NewFileUploadLayout";
import Table from "../../components/Table/Table";
import GridTable from "../../components/GridTable/GridTable";
import MuiPopover from "../../components/UI/MuiPopover";
import ImageCard from "../../components/UI/ImageCard/ImageCard";
import JustifiedVirtuosoGallery from "../../components/JustifiedVirtuosoGallery/JustifiedVirtuosoGallery";
import GridGallery from "../../components/GridGallery/GridGallery";
import CardGallery from "../../components/CardGallery/CardGallery";
import ImageSlider from "../../components/ImageSlider/ImageSlider";
import {
  closeFileSideBar,
  openFileSideBar,
  setFileDetails,
} from "../../store/state-slices/fileDetailsSidebar";

const MenuButton = (props) => {
  return (
    <ActionButton
      icon={<Menu height="20px" width="20px" />}
      kind="tertiary"
      size="medium"
      {...props}
    />
  );
};

const SortBtn = (props) => <Icon ic={"IcChevronDown"} {...props} size="l" />;

const SortComponent = ({
  setSortValue = () => { },
  sortValue = "",
  setSortConfig = () => { },
  close = () => { },
}) => {
  return (
    <div className={"filter-menu"}>
      <div
        className={"filter-item"}
        onClick={() => {
          // setSortValue("name");
          setSortConfig((pre) => ({ ...pre, field: "objectName" }));
          close();
        }}>
        <span>
          <Text text="Name" color="grey-80" />
        </span>
      </div>

      <div
        className={"filter-item"}
        onClick={() => {
          // setSortValue("size");
          setSortConfig((pre) => ({ ...pre, field: "fileSize" }));
          close();
        }}>
        <span>
          <Text text="Size" color="grey-80" />
        </span>
      </div>
      <div
        className={"filter-item"}
        onClick={() => {
          // setSortValue("createdAt");
          setSortConfig((pre) => ({ ...pre, field: "createdAt" }));
          close();
        }}>
        <span>
          <Text text="Uploaded On" color="grey-80" />
        </span>
      </div>
    </div>
  );
};

const PicOptionBtn = (props) => (
  <Button label="Picture Options" kind="secondary" size="small" {...props} />
);

const gridComponents = {
  List: forwardRef(({ style, children, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      style={{
        display: "flex",
        flexWrap: "wrap",
        // display: "grid",
        // gridTemplateColumns: " repeat(auto-fit, minmax(250px, 1fr))",
        ...style,
      }}>
      {children}
    </div>
  )),
  Item: ({ children, ...props }) => (
    <div
      {...props}
      style={{
        padding: "0.5rem",
        width: "200px",
        display: "flex",
        flex: "none",
        alignContent: "stretch",
        boxSizing: "border-box",
      }}>
      {children}
    </div>
  ),
};
const NewPhotos = () => {
  const eventFID = localStorage.getItem("eventFID");
  const { fid: folderId, id: eventId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleFileDownloadOP, reindexStaus } = useContext(FileUploadContext);
  const { handleFileUpload } = useContext(NewFileUploadContext);
  const { photoUpload } = useSelector((state) => state.apiTrigger);
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const { fileDetails, isFileSideBarOpen } = useSelector(
    (state) => state.fileDetailsSideBar || {},
  );
  const { sendRequest: eventPhotosReq, isLoading: evenPhotosReqing } =
    useApiHttp();
  const { sendRequest: albumDetailReq, isLoading: albumDetailReqing } =
    useApiHttp();
  const { sendRequest: deleteImgReq, isLoading: deleteImgReqing } =
    useApiHttp();
  const { sendRequest: approvalReq, isLoading: approvalReqing } = useApiHttp();
  const { sendRequest: updataeWatermarkReq, isLoading: waterReqUpdating } =
    useApiHttp();
  const { sendRequest: getWatermarkReq, isLoading: waterReqGeting } =
    useApiHttp();
  const { sendRequest: getFrameReq, isLoading: frameReqGeting } = useApiHttp();
  const { sendRequest: updateFrameReq, isLoading: frameReqUpdating } =
    useApiHttp();
  const [albumName, setAlbumName] = useState("");
  const [view, setView] = useState(3);
  const [rowHeight, setRowHeight] = useState(500);
  const [sortConfig, setSortConfig] = useState({
    field: "createdAt",
    direction: "desc",
  });

  const [sortValue, setSortValue] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [lastPage, setLastPage] = useState(0);
  const [page, setPage] = useState(0);
  const [photosList, setPhotosList] = useState([]);
  const [previewImgArr, setPreviewImgArr] = useState([]);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
    openKey: 0,
  });
  const [photosCount, setPhotosCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [selectedPhotoIds, setSelectedPhotoIds] = useState(() => new Set());
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [anchorIndex, setAnchorIndex] = useState(null);
  const [check, setCheck] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  const [deleteCount, setDeleteCount] = useState(0);
  const [deleteConfirmation, setDeleteConfirmation] = useState(true);
  const [watermarkStatus, setWatermarkStatus] = useState(false);
  const [frameData, setFrameData] = useState(null);
  const [frameStatus, setFrameStatus] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [value, setValue] = useState("");
  const [photoDataTypes, setPhotoDataTypes] = useState({});
  const fileInputRef = useRef();
  const dragDepthRef = useRef(0);
  const [isDragOverUpload, setIsDragOverUpload] = useState(false);
  const isPhotographer = eventDetails?.userRole === "PHOTOGRAPHER";
  const isAdmin = eventDetails?.userRole === "ADMIN";
  const params = new URLSearchParams(useLocation().search);
  const folderType = params.get("folderType");
  const canUploadPhotos =
    (isAdmin && folderType === "Event" && selectedTab === "event") ||
    (isPhotographer && selectedTab === "uploadPhotosAsPhotographer");
  const uploadPageClassName = [
    "new-photos-page",
    canUploadPhotos ? "new-photos-page--upload-enabled" : "",
    isDragOverUpload ? "new-photos-page--drag-over" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const emptyStateClassName = [
    "new-photos-empty-state",
    canUploadPhotos ? "new-photos-empty-state--upload-enabled" : "",
    isDragOverUpload ? "new-photos-empty-state--drag-over" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const openLightboxOnSlide = useCallback((number) => {
    setLightboxController((prev) => ({
      toggler: true,
      slide: number - 1,
      openKey: prev.openKey + 1,
    }));
  }, []);

  const tileRefs = useRef([]);

  const isEditableTarget = (target) => {
    if (!target) return false;
    const tagName = target.tagName?.toLowerCase();
    return (
      ["input", "textarea", "select"].includes(tagName) ||
      target.isContentEditable ||
      Boolean(target.closest?.("[contenteditable='true']"))
    );
  };

  const getPhotoRangeIds = useCallback(
    (startIndex, endIndex) => {
      if (!photosList.length) return [];
      const start = Math.max(0, Math.min(startIndex, endIndex));
      const end = Math.min(photosList.length - 1, Math.max(startIndex, endIndex));
      return photosList.slice(start, end + 1).map((photo) => photo.id);
    },
    [photosList],
  );

  const applySelectedIds = useCallback(
    (ids) => {
      const selectedSet = new Set(ids);
      setSelectedPhotoIds(selectedSet);
      setSelectedId([...selectedSet]);
      setCheck(photosList.map((photo) => selectedSet.has(photo.id)));
      setSelectAll(selectedSet.size > 0 && selectedSet.size === photosList.length);
    },
    [photosList],
  );

  const clearSelection = useCallback(() => {
    applySelectedIds([]);
  }, [applySelectedIds]);

  const getSelectedPhotoIds = useCallback(() => {
    return selectedPhotoIds.size > 0 ? [...selectedPhotoIds] : selectedId;
  }, [selectedId, selectedPhotoIds]);

  const selectedPhotoCount =
    selectedPhotoIds.size > 0 ? selectedPhotoIds.size : selectedId.length;

  const openDeleteConfirmation = useCallback(() => {
    const deleteIds = getSelectedPhotoIds();
    if (deleteIds.length === 0) return;
    setSelectedId(deleteIds);
    setSelectedPhotoIds(new Set(deleteIds));
    setDeleteConfirmation(false);
  }, [getSelectedPhotoIds]);

  const togglePhotoSelection = useCallback(
    (index) => {
      const photo = photosList[index];
      if (!photo) return;
      const next = new Set(selectedPhotoIds);
      if (next.has(photo.id)) {
        next.delete(photo.id);
      } else {
        next.add(photo.id);
      }
      applySelectedIds([...next]);
      setAnchorIndex(index);
    },
    [applySelectedIds, photosList, selectedPhotoIds],
  );

  const selectRange = useCallback(
    (fromIndex, toIndex) => {
      applySelectedIds(getPhotoRangeIds(fromIndex, toIndex));
    },
    [applySelectedIds, getPhotoRangeIds],
  );

  const registerPhotoTileRef = useCallback((index, node) => {
    tileRefs.current[index] = node;
  }, []);

  const getRegisteredTile = useCallback((index) => {
    return (
      tileRefs.current[index] ||
      document.querySelector(`[data-photo-index="${index}"]`)
    );
  }, []);

  const getPhotoScroller = useCallback((node) => {
    return (
      node?.closest?.(".custom-scrollbar") ||
      document.querySelector(".custom-scrollbar")
    );
  }, []);

  const focusPhotoTile = useCallback(
    (index, shouldScroll = true, navigationKey = "") => {
      const nextIndex = Math.max(0, Math.min(index, photosList.length - 1));
      setFocusedIndex(nextIndex);

      const focusNode = (attempt = 0) => {
        const node = getRegisteredTile(nextIndex);
        if (!node) {
          const currentNode =
            document.activeElement?.closest?.("[data-photo-index]") ||
            getRegisteredTile(focusedIndex);
          const scroller = getPhotoScroller(currentNode);
          const currentHeight =
            currentNode?.getBoundingClientRect?.().height || rowHeight || 220;
          const scrollDelta =
            navigationKey === "ArrowUp" ? -currentHeight : currentHeight;

          if (shouldScroll && scroller && navigationKey) {
            scroller.scrollBy({ top: scrollDelta, behavior: "smooth" });
          }

          if (attempt < 6) {
            setTimeout(() => focusNode(attempt + 1), 50);
          }
          return;
        }
        node.focus({ preventScroll: true });
        if (shouldScroll) {
          node.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      };

      requestAnimationFrame(() => {
        focusNode();
      });
    },
    [focusedIndex, getPhotoScroller, getRegisteredTile, photosList.length, rowHeight],
  );

  const getNextGridIndex = useCallback(
    (key) => {
      const currentNode = getRegisteredTile(focusedIndex);
      if (!currentNode) {
        if (key === "ArrowLeft" || key === "ArrowUp") return Math.max(0, focusedIndex - 1);
        return Math.min(photosList.length - 1, focusedIndex + 1);
      }

      if (key === "ArrowLeft") return Math.max(0, focusedIndex - 1);
      if (key === "ArrowRight") return Math.min(photosList.length - 1, focusedIndex + 1);

      const currentRect = currentNode.getBoundingClientRect();
      const currentCenterX = currentRect.left + currentRect.width / 2;
      const currentCenterY = currentRect.top + currentRect.height / 2;
      let bestIndex = focusedIndex;
      let bestScore = Number.POSITIVE_INFINITY;
      const visibleIndexes = [];

      tileRefs.current.forEach((node, index) => {
        if (!node || index === focusedIndex) return;
        visibleIndexes.push(index);
        const rect = node.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const verticalDelta = centerY - currentCenterY;
        if (key === "ArrowUp" && verticalDelta >= -1) return;
        if (key === "ArrowDown" && verticalDelta <= 1) return;
        const score = Math.abs(verticalDelta) * 10000 + Math.abs(centerX - currentCenterX);
        if (score < bestScore) {
          bestScore = score;
          bestIndex = index;
        }
      });

      if (bestIndex !== focusedIndex) return bestIndex;

      const sortedVisibleIndexes = visibleIndexes.sort((a, b) => a - b);
      if (key === "ArrowUp") {
        return (
          [...sortedVisibleIndexes].reverse().find((index) => index < focusedIndex) ??
          Math.max(0, focusedIndex - 1)
        );
      }
      if (key === "ArrowDown") {
        return (
          sortedVisibleIndexes.find((index) => index > focusedIndex) ??
          Math.min(photosList.length - 1, focusedIndex + 1)
        );
      }

      return focusedIndex;
    },
    [focusedIndex, getRegisteredTile, photosList.length],
  );

  const queueFilesForUpload = useCallback(
    (files) => {
      const uploadFiles = Array.from(files || []);
      if (!uploadFiles.length) return;

      if (reindexStaus?.[eventId] === "PENDING") {
        dispatch(setReindexAlertModalClose(false));
        return;
      }

      handleFileUpload(
        uploadFiles,
        eventId,
        folderId,
        albumName,
        eventDetails?.userRole,
      );
    },
    [
      albumName,
      dispatch,
      eventDetails?.userRole,
      eventId,
      folderId,
      handleFileUpload,
      reindexStaus,
    ],
  );

  const openUploadFilePicker = useCallback(() => {
    if (reindexStaus?.[eventId] === "PENDING") {
      dispatch(setReindexAlertModalClose(false));
      return;
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  }, [dispatch, eventId, reindexStaus]);

  const hasDraggedFiles = (event) =>
    Array.from(event.dataTransfer?.types || []).includes("Files");

  const handleUploadDragEnter = useCallback(
    (event) => {
      if (!canUploadPhotos || !hasDraggedFiles(event)) return;
      event.preventDefault();
      event.stopPropagation();
      dragDepthRef.current += 1;
      setIsDragOverUpload(true);
    },
    [canUploadPhotos],
  );

  const handleUploadDragOver = useCallback(
    (event) => {
      if (!canUploadPhotos || !hasDraggedFiles(event)) return;
      event.preventDefault();
      event.stopPropagation();
      event.dataTransfer.dropEffect = "copy";
      setIsDragOverUpload(true);
    },
    [canUploadPhotos],
  );

  const handleUploadDragLeave = useCallback(
    (event) => {
      if (!canUploadPhotos || !hasDraggedFiles(event)) return;
      event.preventDefault();
      event.stopPropagation();
      dragDepthRef.current = Math.max(0, dragDepthRef.current - 1);
      if (dragDepthRef.current === 0) {
        setIsDragOverUpload(false);
      }
    },
    [canUploadPhotos],
  );

  const handleUploadDrop = useCallback(
    (event) => {
      if (!hasDraggedFiles(event)) return;
      event.preventDefault();
      event.stopPropagation();
      dragDepthRef.current = 0;
      setIsDragOverUpload(false);

      if (!canUploadPhotos) return;
      queueFilesForUpload(event.dataTransfer.files);
    },
    [canUploadPhotos, queueFilesForUpload],
  );

  function getUrl(selectedTab, eventId, folderId, page, field, direction) {
    let url = "";

    switch (selectedTab) {
      case "event":
        url = `images?eventId=${eventId}&folderId=${folderId}&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
      case "guest":
        url = `guest-images?eventId=${eventId}&folderId=${folderId}&isPublic=false&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
      case "approved":
        url = `guest-images?eventId=${eventId}&folderId=${folderId}&isPublic=true&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
      case "photographersUploadedPhotos":
        url = `photographer-images?eventId=${eventId}&folderId=${folderId}&isPublic=false&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
      case "photographersApprovedPhotos":
        url = `photographer-images?eventId=${eventId}&folderId=${folderId}&isPublic=true&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
      case "uploadPhotosAsPhotographer":
        url = `photographer-uploads?eventId=${eventId}&folderId=${folderId}&isPublic=false&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
      case "approvedPhotosAsPhotographer":
        url = `photographer-uploads?eventId=${eventId}&folderId=${folderId}&isPublic=true&page=${page}&size=50&sortField=${field}&sortDirection=${direction}`;
        break;
    }

    return url;
  }

  const controller = new AbortController();

  const getEventPhotos = (page, selectedTab) => {
    eventPhotosReq(
      {
        url: getUrl(
          selectedTab,
          eventId,
          folderId,
          page,
          sortConfig.field,
          sortConfig.direction,
        ),
        method: "GET",
        base: "MEDIA",
        signal: controller.signal,
      },
      null,
      (data) => {
        setPhotosCount(data?.count);
        setDeleteCount(0);
        setLastPage(data?.lastPage);
        if (page == 0) {
          setPhotosList(data?.data);
          setCheck(Array(data?.data.length).fill(false));
        } else {
          setPhotosList((pre) => [...pre, ...data?.data]);
          if (selectAll) {
            setCheck((pre) => [...pre, ...Array(data?.data.length).fill(true)]);
            const ids = data?.data?.map((item) => item.id);
            setSelectedId((pre) => [...pre, ...ids]);
            setSelectedPhotoIds((pre) => new Set([...pre, ...ids]));
          } else {
            setCheck((pre) => [
              ...pre,
              ...Array(data?.data.length).fill(false),
            ]);
          }
        }
      },
    );
  };
  const downloadSelectedPhotos = useCallback(() => {
    const downloadIds = getSelectedPhotoIds();
    if (downloadIds.length === 0) return;
    handleFileDownloadOP(
      downloadIds,
      eventId,
      isAdmin ? "ADMIN" : "PHOTOGRAPHER",
    );
    clearSelection();
  }, [
    clearSelection,
    eventId,
    getSelectedPhotoIds,
    handleFileDownloadOP,
    isAdmin,
  ]);

  const handleSelectAllChange = (selectAll) => {
    if (selectAll) {
      const ids = photosList.map((item) => item.id);
      applySelectedIds(ids);
    } else {
      clearSelection();
    }
  };
  const handleCheckboxChange = useCallback(
    (checked, index, id, event) => {
      setFocusedIndex(index);
      focusPhotoTile(index, false);
      const isRangeSelection = event?.shiftKey;
      const isToggleOnly = event?.metaKey || event?.ctrlKey;

      if (isRangeSelection) {
        const rangeAnchor = anchorIndex ?? focusedIndex ?? index;
        setAnchorIndex(rangeAnchor);
        selectRange(rangeAnchor, index);
        return;
      }

      if (isToggleOnly || selectedId.length > 0) {
        const next = new Set(selectedPhotoIds);
        if (checked) {
          next.add(id);
        } else {
          next.delete(id);
        }
        applySelectedIds([...next]);
        setAnchorIndex(index);
        return;
      }

      const nextIds = checked ? [id] : [];
      applySelectedIds(nextIds);
      setAnchorIndex(index);
    },
    [
      anchorIndex,
      applySelectedIds,
      focusPhotoTile,
      focusedIndex,
      selectRange,
      selectedId.length,
      selectedPhotoIds,
    ],
  );

  const handlePhotoClick = useCallback(
    (index, event) => {
      const photo = photosList[index];
      if (!photo) return;
      setFocusedIndex(index);

      if (event?.shiftKey) {
        focusPhotoTile(index, false);
        const rangeAnchor = anchorIndex ?? focusedIndex ?? index;
        setAnchorIndex(rangeAnchor);
        selectRange(rangeAnchor, index);
        return;
      }

      if (event?.metaKey || event?.ctrlKey) {
        focusPhotoTile(index, false);
        togglePhotoSelection(index);
        return;
      }

      openLightboxOnSlide(index + 1);
      setAnchorIndex(index);
    },
    [
      anchorIndex,
      focusPhotoTile,
      focusedIndex,
      openLightboxOnSlide,
      photosList,
      selectRange,
      togglePhotoSelection,
    ],
  );

  const handleEditSuccess = useCallback(() => {
    if (page !== 0) {
      setPage(0);
    } else {
      getEventPhotos(0, selectedTab);
    }
  }, [page, selectedTab]);

  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (evenPhotosReqing) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [evenPhotosReqing, lastPage],
  );
  const noPhotosMessage = {
    event: "The photos that you upload are shown here",
    guest: "The photos that guests upload are shown here",
    approved:
      "Guest-uploaded photos approved by the organizer will appear here.",
    photographersUploadedPhotos:
      "The photos that photographer upload are shown here",
    photographersApprovedPhotos:
      "Photographer-uploaded photos approved by the organizer will appear here.",
    uploadPhotosAsPhotographer: "The photos that you upload are shown here",
    approvedPhotosAsPhotographer:
      "Photos uploaded by you and approved by the organizer will appear here.",
  };
  // Action services
  const deleteImage = (mediaId) => {
    const deleteIds = mediaId ? [mediaId] : getSelectedPhotoIds();
    if (deleteIds.length === 0) return;

    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("mediaIDs", deleteIds);
    deleteImgReq(
      {
        url: isAdmin ? `image/delete` : `photographer/image/delete`,
        method: "DELETE",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "delete-photos",
          title: data.message,
        });
        const pLength = photosList.length;
        setCheck(Array(pLength - deleteIds.length).fill(false));
        setPhotosList((pre) =>
          pre.filter((item) => !deleteIds.includes(item.id)),
        );
        setDeleteCount(deleteCount + deleteIds.length);
        clearSelection();
      },
      (err, data) =>
        Notifications.toast.error({ id: "delete-photos", title: data.message }),
    );
  };

  const approvePhoto = (status, userType = "Guest") => {
    console.log("test1234");
    const mediaIds = selectedId;
    const formData = new FormData();

    formData.append("mediaIDs", mediaIds);
    formData.append("status", status);
    formData.append("eventId", eventId);

    approvalReq(
      {
        url:
          userType == "Guest"
            ? "set-multiple-media-privacy"
            : "set-folder-media-privacy",
        base: "MEDIA",
        method: "PUT",
        body: formData,
        formData: true,
      },
      null,
      (data) => {
        // setPhotosList((pre) =>
        //   pre.map((item) =>
        //     !mediaIds.includes(item.id) ? item : { ...item, isPublic: status }
        //   )
        // );
        Notifications.toast.success({
          id: "approve-photos",
          title: data.message,
        });
        const pLength = photosList.length;
        setCheck(Array(pLength - mediaIds.length).fill(false));
        setPhotosList((pre) =>
          pre.filter((item) => !mediaIds.includes(item.id)),
        );
        setDeleteCount(deleteCount + mediaIds.length);
        clearSelection();
      },
      (err, data) =>
        Notifications.toast.error({
          id: "approve-photos",
          title: data.message,
        }),
    );
  };
  const getWatermarkDetails = () => {
    getWatermarkReq(
      {
        url: `watermark/event/${eventId}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        console.log("data", data);
        setWatermarkStatus(data?.data?.isActive);
      },
      (err, data) => {
        console.log("Error", data);
      },
    );
  };

  const updateWatermark = (status) => {
    const formData = new FormData();
    formData.append("isActive", status);
    updataeWatermarkReq(
      {
        url: `watermark/event/${eventId}`,
        method: "PATCH",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        getWatermarkDetails();
      },
      (err, data) => { },
    );
  };
  const getFrameDetails = () => {
    getFrameReq(
      {
        url: `frame/frame-details?eventId=${eventId}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFrameStatus(data?.data?.frameStatus);
        if (data?.data?.frameStatus) {
          setFrameData(data?.data);
        } else {
          setFrameData(null);
        }
      },
      (err, data) => {
        console.log("Error", data);
      },
    );
  };
  const updateFrame = (status) => {
    const formData = new FormData();
    formData.append("frameStatus", status);
    formData.append("downloadStatus", false);
    formData.append("eventId", eventId);
    updateFrameReq(
      {
        url: `frame/set-frame-status`,
        method: "PUT",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        getFrameDetails();
      },
      (err, data) => {
        Notifications.toast.error({
          id: "update-frame",
          title: data?.message,
        });
      },
    );
  };
  useEffect(() => {
    if (selectedTab.length > 0) {
      getEventPhotos(page, selectedTab);
    }
    return () => {
      controller.abort();
    };
  }, [page, selectedTab]);
  useEffect(() => {
    setPhotosList([]);
    setCheck([]);
    clearSelection();
    if (page == 0 && selectedTab.length > 0) {
      getEventPhotos(0, selectedTab);
    } else {
      setPage(0);
    }
  }, [sortConfig]);
  useEffect(() => {
    const lastIndex = photosList.length - 1;
    if (photosList.length === 0) {
      setFocusedIndex(0);
      setAnchorIndex(null);
      return;
    }
    setFocusedIndex((prev) => Math.min(prev, lastIndex));
    setAnchorIndex((prev) => (prev === null ? prev : Math.min(prev, lastIndex)));
  }, [photosList.length]);

  useEffect(() => {
    setPreviewImgArr(
      photosList.map((item) =>
        addParamsURL(decryptUrl(item?.reducedFileSignedPath), {
          size: "m",
        }),
      ),
    );
  }, [photosList, frameData]);
  // useEffect(() => {

  // }, [selectedTab]);
  useEffect(() => {
    if (selectedId.length === photosList.length && selectedId.length !== 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedId]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isEditableTarget(event.target) || photosList.length === 0) return;

      const key = event.key;
      const isModifierPressed = event.ctrlKey || event.metaKey;
      const arrowKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];

      if (arrowKeys.includes(key)) {
        event.preventDefault();
        event.stopPropagation();
        const nextIndex = getNextGridIndex(key);
        const rangeAnchor = anchorIndex ?? focusedIndex;
        setFocusedIndex(nextIndex);
        focusPhotoTile(nextIndex, true, key);
        if (event.shiftKey) {
          setAnchorIndex(rangeAnchor);
          selectRange(rangeAnchor, nextIndex);
        } else {
          setAnchorIndex(nextIndex);
        }
        return;
      }

      if (key === " " || key === "Spacebar") {
        event.preventDefault();
        event.stopPropagation();
        togglePhotoSelection(focusedIndex);
        focusPhotoTile(focusedIndex, false);
        return;
      }

      if (isModifierPressed && key.toLowerCase() === "a") {
        event.preventDefault();
        event.stopPropagation();
        applySelectedIds(photosList.map((photo) => photo.id));
        setAnchorIndex(focusedIndex);
        focusPhotoTile(focusedIndex, false);
        return;
      }

      if (key === "Escape") {
        if (!deleteConfirmation) {
          event.preventDefault();
          event.stopPropagation();
          setDeleteConfirmation(true);
          return;
        }
        if (lightboxController.toggler) {
          event.preventDefault();
          event.stopPropagation();
          setLightboxController((prev) => ({ ...prev, toggler: false }));
          return;
        }
        if (selectedPhotoCount > 0) {
          event.preventDefault();
          event.stopPropagation();
          clearSelection();
        }
        return;
      }

      if (key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        openLightboxOnSlide(focusedIndex + 1);
        setAnchorIndex(focusedIndex);
        return;
      }

      if (key === "Delete" || key === "Backspace") {
        if (selectedPhotoCount > 0) {
          event.preventDefault();
          event.stopPropagation();
          openDeleteConfirmation();
        }
        return;
      }

      if (!isModifierPressed && key.toLowerCase() === "d") {
        if (selectedPhotoCount > 0) {
          event.preventDefault();
          event.stopPropagation();
          downloadSelectedPhotos();
        }
        return;
      }

      if (!isModifierPressed && key.toLowerCase() === "i") {
        const focusedPhoto = photosList[focusedIndex];
        if (!focusedPhoto) return;
        event.preventDefault();
        event.stopPropagation();
        if (isFileSideBarOpen && fileDetails?.id === focusedPhoto.id) {
          dispatch(closeFileSideBar());
        } else {
          dispatch(setFileDetails(focusedPhoto));
          dispatch(openFileSideBar());
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [
    anchorIndex,
    applySelectedIds,
    clearSelection,
    deleteConfirmation,
    dispatch,
    downloadSelectedPhotos,
    fileDetails?.id,
    focusPhotoTile,
    focusedIndex,
    getNextGridIndex,
    isFileSideBarOpen,
    lightboxController.toggler,
    openDeleteConfirmation,
    openLightboxOnSlide,
    photosList,
    selectRange,
    selectedPhotoCount,
    togglePhotoSelection,
  ]);

  useEffect(() => {
    if (
      photoUpload[eventId + folderId] &&
      selectedTab !== "guest" &&
      selectedTab !== "approved" &&
      isAdmin
    ) {
      setPhotosList([]);
      if (page !== 0) {
        setPage(0);
      } else {
        getEventPhotos(0, "event");
      }
    }
    if (
      photoUpload[eventId + folderId] &&
      selectedTab !== "approvedPhotosAsPhotographer" &&
      isPhotographer
    ) {
      setPhotosList([]);
      if (page !== 0) {
        setPage(0);
      } else {
        getEventPhotos(0, "uploadPhotosAsPhotographer");
      }
    }
  }, [photoUpload]);
  const [active, setActive] = useState(0);
  useEffect(() => {
    albumDetailReq(
      {
        url: `event-folders/getfolder?eventId=${eventId}&folderId=${eventFID}`,
      },
      null,
      (data) => setAlbumName(data?.data?.name),
    );
    const allowedFolderTypes = ["Photographer", "Event"];
    console.log("hello1234==>test", folderType);

    if (!folderType || !allowedFolderTypes.includes(folderType)) {
      navigate(`/home/events/albums/${eventId}`);
    }
    // getFrameDetails();
    // getWatermarkDetails();
  }, []);
  useEffect(() => {
    if (isAdmin && folderType == "Event") {
      setPhotoDataTypes({
        event: "Event Photos",
        guest: "Guest Uploaded Photos",
        approved: "Guest Approved Photos",
      });
      setValue("Event Photos");
      setSelectedTab("event");
    }
    if (isAdmin && folderType == "Photographer") {
      setPhotoDataTypes({
        photographersUploadedPhotos: "Photographer Uploaded Photos",
        photographersApprovedPhotos: "Photographer Approved Photos",
      });
      setValue("Photographer Uploaded Photos");
      setSelectedTab("photographersUploadedPhotos");
    }
    if (isPhotographer && folderType == "Photographer") {
      setPhotoDataTypes({
        uploadPhotosAsPhotographer: "Uploaded Photos",
        approvedPhotosAsPhotographer: "Approved Photos",
      });
      setValue("Uploaded Photos");
      setSelectedTab("uploadPhotosAsPhotographer");
    }
  }, [isAdmin, folderType]);
  return (
    <>
      <input
        type="file"
        accept=".png, .jpg, .jpeg"
        id="banner-file__upload"
        // onChange={handleFileChange}
        onChange={(e) => {
          queueFilesForUpload(e.target.files);
          e.target.value = null;
        }}
        style={{ display: "none" }}
        ref={fileInputRef}
        multiple
      />

      <div>
        <Container horizontalAlign="space-between" fullWidth>
          <Container direction="column" gap={8}>
            {/* <div
              onClick={() => navigate(-1)}
              style={{
                cursor: "pointer",
                display: "flex",
                marginBottom: "16px",
              }}
            >
              <Icon ic={"IcChevronLeft"} color="primary_60" />
              <Text text="Back" appearance="body_s_bold" color="primary_60" />
            </div> */}

            <div
              style={{
                display: "flex",
                marginBottom: "16px",
                alignItems: "center",
                gap: "12px",
              }}>
              <Icon
                ic={"IcBack"}
                color="primary_60"
                onClick={() => {
                  navigate(`/home/events/albums/${eventId}`, {
                    state: {
                      photographerTab: isAdmin && folderType == "Photographer",
                    },
                  });
                }}
              />
              <Text text="Albums" appearance="heading-xs" />
            </div>
            {albumName ? (
              <Text
                text={`${albumName || ""} - ${photosCount - deleteCount || 0} ${photosCount - deleteCount > 1 ? "Photos" : "Photo"
                  }`}
                appearance="body-m"
                color="primary-grey-80"
              />
            ) : (
              <Skeleton
                variant="text"
                sx={{ fontSize: "1rem", width: "100%" }}
              />
            )}
          </Container>
          <Container gap={8}>
            {isAdmin && folderType == "Event" && (
              <>
                {(photosList.length > 0 || selectedTab !== "event") && (
                  <ActionButton
                    label="Upload Photos"
                    kind="secondary"
                    size="medium"
                    icon="IcUpload"
                    onClick={() => {
                      openUploadFilePicker();
                    }}
                    appearance=""
                  />
                )}
              </>
            )}
            {isPhotographer && (
              <>
                {(photosList.length > 0 ||
                  selectedTab !== "uploadPhotosAsPhotographer") && (
                    <ActionButton
                      label="Upload Photos"
                      kind="secondary"
                      size="medium"
                      icon="IcUpload"
                      onClick={() => {
                        openUploadFilePicker();
                      }}
                      appearance=""
                    />
                  )}
              </>
            )}
          </Container>
        </Container>

        <div
          style={{
            display: selectedPhotoCount == 0 ? "flex" : "none",
            justifyContent: "space-between",
            marginBlock: "10px",
          }}>
          <div className="photopage-selector">
            <Selectors
              // selectedIndex={0}
              onChange={(val) => {
                if (val !== selectedTab) {
                  setSelectedTab(val);
                  setPage(0);
                  setPhotosList([]);
                  setCheck([]);
                  clearSelection();
                }
              }}
              items={
                isPhotographer && folderType == "Photographer"
                  ? [
                    {
                      label: "Uploaded Photos",
                      value: "uploadPhotosAsPhotographer",
                    },
                    {
                      label: "Approved Photos",
                      value: "approvedPhotosAsPhotographer",
                    },
                  ]
                  : isAdmin && folderType == "Photographer"
                    ? [
                      {
                        label: "Photographer Uploaded Photos",
                        value: "photographersUploadedPhotos",
                      },
                      {
                        label: "Photographer Approved Photos",
                        value: "photographersApprovedPhotos",
                      },
                    ]
                    : [
                      {
                        label: "Event Photos",
                        value: "event",
                      },
                      {
                        label: "Guest Uploaded Photos",
                        value: "guest",
                      },
                      {
                        label: "Guest Approved Photos",
                        value: "approved",
                      },
                    ]
              }
            />
            <div
              style={{ position: "relative" }}
              className="phototype-dropdown">
              <ActionButton
                kind="primary"
                label={value || "Event Photos"}
                icon="IcChevronDown"
                size="medium"
                iconPosition="right"
                onClick={() => {
                  setOpenDropdown(true);
                }}
              />
              <div
                className="drop"
              // style={{
              //   position: "absolute !important",
              //   top: "38dvh !important",
              //   left: "23dvw !important",
              // }}
              >
                <DropdownMenu
                  className="drop"
                  open={openDropdown}
                  position="bottom-start"
                  onClose={() => setOpenDropdown(false)}
                  value={value}
                  onSelect={(val) => {
                    console.log(val);
                    setValue(photoDataTypes[val]);
                    setSelectedTab(val);
                    setPage(0);
                    setPhotosList([]);
                    setCheck([]);
                    clearSelection();
                  }}>
                  <DropdownMenuGroup hideBottomDivider>
                    {Object.entries(photoDataTypes).map(([value, label]) => (
                      <DropdownMenuItem
                        key={value}
                        value={value}
                        label={label}
                      />
                    ))}
                  </DropdownMenuGroup>
                </DropdownMenu>
              </div>
            </div>
          </div>
          {photosList.length > 0 && (
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}>
              {(view === 1 || view === 3 || view === 2) && (
                <>
                  {view === 3 && (
                    <input
                      type="range"
                      min={220}
                      max={700}
                      onChange={(e) => {
                        setRowHeight(e.target.value);
                      }}
                      value={rowHeight}
                      className="slider"
                    />
                  )}
                  <span
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      cursor: "pointer ",
                    }}
                    onClick={() => {
                      setSortConfig((pre) => ({
                        ...pre,
                        direction: pre.direction === "asc" ? "desc" : "asc",
                      }));
                    }}>
                    <Icon
                      ic={
                        sortConfig.direction == "asc"
                          ? "IcArrowUp"
                          : "IcArrowDown"
                      }
                      size="s"
                    />
                    <Text
                      text={
                        sortConfig.field == "objectName"
                          ? "Name"
                          : sortConfig.field == "fileSize"
                            ? "Size"
                            : "Uploaded On"
                      }
                    />
                  </span>
                  <MuiPopover
                    trigger={{
                      component: SortBtn,
                    }}
                    sx={{
                      borderRadius: "5px",
                    }}>
                    <SortComponent
                      setSortValue={setSortValue}
                      sortValue={sortValue}
                      setSortConfig={setSortConfig}
                    />
                  </MuiPopover>
                </>
              )}
              <div className="icon-btn-group">
                <button
                  className={`icon-btn ${view === 3 ? "active" : ""}`}
                  onClick={() => setView(3)}
                  title="Justified view">
                  <Icon ic="IcLayout" />
                </button>
                <button
                  className={`icon-btn ${view === 1 ? "active" : ""}`}
                  onClick={() => setView(1)}
                  title="Thumbnail view">
                  <Icon ic="IcAssistiveGrid" />
                </button>

                <button
                  className={`icon-btn ${view === 2 ? "active" : ""}`}
                  onClick={() => setView(2)}
                  title="Tile view">
                  <Icon ic="IcTicketDetails" />
                </button>
                <button
                  className={`icon-btn ${view === 4 ? "active" : ""}`}
                  onClick={() => setView(4)}
                  title="List view">
                  <Icon ic="IcList" />
                </button>
              </div>
            </div>
          )}
        </div>

        {photosList.length > 0 && selectedPhotoCount > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#f5f5f5",
              padding: "4px 16px",
              borderRadius: "24px",
              "--color-primary-60": "#444746",
              marginBlock: "10px",
            }}>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}>
              {" "}
              <Box
                sx={{
                  "--color-primary-grey-60": "#444746",
                  cursor: "pointer",
                }}
                title="Clear selection"
                onClick={() => {
                  clearSelection();
                }}>
                <Icon ic={"IcCloseRemove"} color="grey-60" size="m" />
              </Box>
              <ActionButton
                // label={`Selected ${
                //   selectAll ? photosCount - deleteCount : selectedId.length
                // }`}
                label={`Selected ${selectedPhotoCount}`}
                icon={"IcImage"}
                kind="secondary"
                size="small"
              // onClick={() => {
              //   setSelectedId([]);
              //   setCheck((pre) => Array(pre.length).fill(false));
              // }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}>
                {/* {eventDetails?.userRole == "ADMIN" && (
              <Container>
                <JdsMenu
                  trigger={{ component: PicOptionBtn }}
                  onSelect={(value) => {}}
                >
                  <DropdownMenuGroup hideBottomDivider>
                    <DropdownMenuItem
                      value="watermark"
                      prefix={
                        watermarkStatus ? "IcCheckboxOn" : "IcCheckboxOff"
                      }
                      label="Watermark"
                      onClick={() => {
                        updateWatermark(!watermarkStatus);
                      }}
                    />
                    <DropdownMenuItem
                      value="frame"
                      prefix={frameStatus ? "IcCheckboxOn" : "IcCheckboxOff"}
                      label="Frame"
                      onClick={() => {
                        updateFrame(!frameStatus);
                      }}
                    />
                  </DropdownMenuGroup>
                </JdsMenu>
              </Container>
            )} */}
              </div>
              <ActionButton
                icon={selectAll ? "IcCheckboxOn" : "IcCheckboxIndeterminate"}
                label="Select"
                size="small"
                kind="secondary"
                onClick={() => {
                  handleSelectAllChange(!selectAll);
                }}
              />
              <ActionButton
                icon={"IcDownload"}
                label="Download"
                size="small"
                kind="secondary"
                onClick={() => {
                  downloadSelectedPhotos();
                }}
              />
              <JdsMenu
                trigger={{
                  component: MenuButton,
                  componentProps: {
                    style: {
                      marginTop: "3px",
                    },
                  },
                }}>
                <DropdownMenuGroup hideBottomDivider>
                  {selectedTab === "guest" && (
                    <DropdownMenuItem
                      prefix={"IcPhoto"}
                      label="Approve Photo"
                      value="approve"
                      onClick={() => {
                        approvePhoto(true, "Guest");
                      }}
                    />
                  )}
                  {selectedTab === "approved" && (
                    <DropdownMenuItem
                      prefix={"IcError"}
                      label="Disapprove Photo"
                      value="disapprove"
                      onClick={() => {
                        approvePhoto(false, "Guest");
                      }}
                    />
                  )}
                  {/* {selectedTab === "photographersUploadedPhotos" && (
                  <DropdownMenuItem
                    prefix={"IcPhoto"}
                    label="Approve Photo"
                    value="approve"
                    onClick={() => {
                      approvePhoto(true, "Photographer");
                    }}
                  />
                )}
                {selectedTab === "photographersApprovedPhotos" && (
                  <DropdownMenuItem
                    prefix={"IcError"}
                    label="Disapprove Photo"
                    value="disapprove"
                    onClick={() => {
                      approvePhoto(false, "Photographer");
                    }}
                  />
                )} */}
                  {/* {isAdmin && ( */}
                  <DropdownMenuItem
                    prefix={"IcTrash"}
                    label="Delete"
                    value="delete"
                    onClick={() => {
                      openDeleteConfirmation();
                    }}
                  />
                  {/* )} */}

                  {/* <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" /> */}
                </DropdownMenuGroup>
              </JdsMenu>
            </div>
            <div>
              <Tooltip
                title="You can delete up to 50 photos at a time from an album"
                placement="bottom"
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#fff", // Custom background
                      fontSize: "16px", // Font size
                      padding: "2px 6px",
                      borderRadius: "4px",
                      fontWeight: "700",
                      color: "#444746",
                    },
                  },
                }}>
                <Box
                  sx={{
                    "--color-primary-grey-60": "#444746",
                  }}>
                  <Icon ic={"IcInfo"} color="grey-60" size="m" />
                </Box>
              </Tooltip>
            </div>
          </div>
        )}
      </div>
      {/* <JdsModal
        header={
          <>
            <Text
              text={
                selectedPhotoCount > 50
                  ? `You can delete a maximum of 50 images at a time.`
                  : `You have selected ${selectedPhotoCount} image(s) to delete.`
              }
              appearance="body_m_bold"
            />
            <Text
              text={
                selectedPhotoCount > 50
                  ? `Deselect some images to continue.`
                  : `This action cannot be undone.`
              }
              color="primary-grey-80"
            />
          </>
        }
        size="m"
        kind="dialog"
        close={deleteConfirmation}
        onClose={() => {
          setDeleteConfirmation(true);
        }}
        onPrimaryClick={() => {
          deleteImage();
          setDeleteConfirmation(true);
        }}
        onSecondaryClick={() => setDeleteConfirmation(true)}
        {...(selectedPhotoCount <= 50 && {
          primaryCTA: { title: "Yes" },
          secondaryCTA: { title: "No" },
        })}
      ></JdsModal> */}

      <div
        className={uploadPageClassName}
        onDragEnter={handleUploadDragEnter}
        onDragOver={handleUploadDragOver}
        onDragLeave={handleUploadDragLeave}
        onDrop={handleUploadDrop}>
        {page === 0 && evenPhotosReqing && (
          <Container
            fullWidth
            horizontalAlign="center"
            verticalAlign="center"
            style={{ minHeight: "220px" }}>
            <Spinner kind="primary" label="Loading..." size="large" />
          </Container>
        )}

        {photosList.length == 0 && !evenPhotosReqing && (
          <>
            <div
              className={emptyStateClassName}
              style={{
                marginTop: "140px",
              }}>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}>
                {/* <div style={{ textAlign: "center" }}>
                <Icon ic={"IcCloudUpload"} size="xxl" />
              </div> */}
                <div>
                  <img
                    src={uploadPhotos}
                    style={{ borderRadius: "24px", width: "240px" }}
                  />
                </div>
                <div>
                  {selectedTab == "event" && (
                    <>
                      <ActionButton
                        label="Upload Photos"
                        kind="secondary"
                        size="medium"
                        // icon="IcUpload"
                        onClick={() => {
                          openUploadFilePicker();
                        }}
                        appearance=""
                      />
                    </>
                  )}{" "}
                  {selectedTab == "uploadPhotosAsPhotographer" && (
                    <>
                      <ActionButton
                        label="Upload Photos"
                        kind="secondary"
                        size="medium"
                        onClick={() => {
                          openUploadFilePicker();
                        }}
                        appearance=""
                      />
                    </>
                  )}
                </div>
                <Text
                  // text={
                  //   selectedTab == "event"
                  //     ? `The photos that you upload are shown here`
                  //     : selectedTab == "guest"
                  //       ? `The photos that guests upload are shown here`
                  //       : selectedTab == "approved"
                  //         ? `Guest-uploaded photos approved by the organizer will appear here.`
                  //         : `No Photos`
                  // }
                  text={noPhotosMessage[selectedTab]}
                  appearance="body_s"
                  color="primary-grey-80"
                />
              </div>
            </div>
          </>
        )}
        {photosList.length > 0 && (
          <>
            {view === 1 && (
              <div
                style={{
                  height: "calc(100vh - 260px)",
                }}>
                {" "}
                <GridGallery
                  images={photosList}
                  endReached={() => {
                    if (lastPage > page) {
                      setPage((pre) => pre + 1);
                    }
                  }}
                  loading={evenPhotosReqing}
                  onCheckBoxChange={handleCheckboxChange}
                  selectedId={selectedId}
                  isAdmin={isAdmin}
                  selectedTab={selectedTab}
                  onClick={handlePhotoClick}
                  focusedIndex={focusedIndex}
                  onTileFocus={setFocusedIndex}
                  registerPhotoTileRef={registerPhotoTileRef}
                />
              </div>
            )}
            {view === 2 && (
              <div
                style={{
                  height: "calc(100vh - 260px)",
                }}>
                {" "}
                <CardGallery
                  images={photosList}
                  endReached={() => {
                    if (lastPage > page) {
                      setPage((pre) => pre + 1);
                    }
                  }}
                  loading={evenPhotosReqing}
                  onCheckBoxChange={handleCheckboxChange}
                  selectedId={selectedId}
                  isAdmin={isAdmin}
                  selectedTab={selectedTab}
                  onClick={handlePhotoClick}
                  focusedIndex={focusedIndex}
                  onTileFocus={setFocusedIndex}
                  registerPhotoTileRef={registerPhotoTileRef}
                />
              </div>
            )}
            {view === 3 && (
              <div
                style={{
                  height: "calc(100vh - 260px)",
                }}>
                <JustifiedVirtuosoGallery
                  images={photosList}
                  endReached={() => {
                    if (lastPage > page) {
                      setPage((pre) => pre + 1);
                    }
                  }}
                  rowHeight={rowHeight}
                  loading={evenPhotosReqing}
                  onCheckBoxChange={handleCheckboxChange}
                  selectedId={selectedId}
                  isAdmin={isAdmin}
                  selectedTab={selectedTab}
                  onClick={handlePhotoClick}
                  focusedIndex={focusedIndex}
                  onTileFocus={setFocusedIndex}
                  registerPhotoTileRef={registerPhotoTileRef}
                />
              </div>
            )}
            {view === 4 && (
              <GridTable
                // height={"100px"}
                columns={[
                  {
                    field: "objectName",
                    headerName: "Name",
                    sortable: true,
                    flex: 2,
                    renderCell: ({ row, index }) => (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: "100%",
                          cursor: "pointer",
                        }}
                        title={row.name}
                        onClick={(event) => {
                          if (
                            event.shiftKey ||
                            event.ctrlKey ||
                            event.metaKey
                          ) {
                            event.stopPropagation();
                            handlePhotoClick(index, event);
                            return;
                          }
                          openLightboxOnSlide(index + 1);
                        }}>
                        <ImageCard
                          src={addParamsURL(
                            decryptUrl(row?.thumbnailFileSignedPath),
                            {
                              size: "s",
                            },
                          )}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "5px",
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                        <span className="text-overflow-ellipsis">
                          {row.fileName || "Album Photos"}
                        </span>
                      </span>
                    ),
                  },
                  {
                    field: "fileSize",
                    headerName: "Size",
                    sortable: true,
                    flex: 1,
                    renderCell: ({ row }) => bytesToHumanReadable(row.fileSize),
                  },
                  {
                    field: "createdAt",
                    headerName: "Uploaded On",
                    sortable: true,
                    flex: 1,
                    renderCell: ({ row }) => getArrtoDate(row?.createdAt),
                  },
                ]}
                rows={photosList}
                rowCheckBoxSelction={
                  selectedTab !== "approvedPhotosAsPhotographer" ? true : false
                }
                lastElement={() => {
                  if (lastPage > page) {
                    setPage((pre) => pre + 1);
                  }
                }}
                onRowCheckBoxChange={handleCheckboxChange}
                selectedId={selectedId}
                isLoading={evenPhotosReqing}
                onSortModelChange={setSortConfig}
                sortConfigValue={sortConfig}
                focusedIndex={focusedIndex}
                onTileFocus={setFocusedIndex}
                registerPhotoTileRef={registerPhotoTileRef}
                onRowClick={handlePhotoClick}
              />
            )}
          </>
        )}
      </div>
      {(deleteImgReqing || approvalReqing) && (
        <PageLoader
          open={deleteImgReqing || approvalReqing}
          label={
            deleteImgReqing || (approvalReqing && "Please wait for a while...")
          }
        />
      )}

      {/* {previewImgArr.length ? (
        <FsLightbox
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
        // disableLocalStorage={true}
        />
      ) : null} */}

      <JdsModal
        size="m"
        kind="custom"
        close={deleteConfirmation}
        onClose={() => {
          setDeleteConfirmation(true);
        }}
        headerProps={{ divider: "false" }}>
        <div>
          <Stack gap={0.5}>
            <Text
              text={
                selectedPhotoCount > 50
                  ? `You can delete a maximum of 50 images at a time.`
                  : `You have selected ${selectedPhotoCount} image(s) to delete.`
              }
              appearance="heading_xs"
            />
            <Text
              text={
                selectedPhotoCount > 50
                  ? `Deselect some images to continue.`
                  : `These items will get permanently deleted from PhotoShare.`
              }
              appearance="body_s"
              color="primary-grey-80"
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"end"}
            gap={"12px"}
            mt={"8px"}>
            {selectedPhotoCount > 50 ? (
              <ActionButton
                label="Ok"
                kind="primary"
                size="medium"
                onClick={() => {
                  setDeleteConfirmation(true);
                }}
                appearance=""
              />
            ) : (
              <>
                <ActionButton
                  label="Cancel"
                  kind="secondary"
                  size="medium"
                  onClick={() => {
                    setDeleteConfirmation(true);
                  }}
                  appearance=""
                />
                <ActionButton
                  label="Delete"
                  kind="primary"
                  size="medium"
                  onClick={() => {
                    deleteImage();
                    setDeleteConfirmation(true);
                  }}
                  appearance=""
                />
              </>
            )}
          </Stack>
        </div>
      </JdsModal>
      {lightboxController.toggler && (
        <ImageSlider
          key={lightboxController.openKey}
          toggler={lightboxController.toggler}
          slide={lightboxController.slide}
          sources={photosList}
          totalCount={photosCount}
          onClose={() =>
            setLightboxController((prev) => ({
              ...prev,
              toggler: false,
            }))
          }
          endReached={() => {
            if (lastPage > page) {
              setPage((pre) => pre + 1);
            }
          }}
          loading={evenPhotosReqing}
          deleteImage={deleteImage}
          isAdmin={isAdmin}
          handleEditSuccess={handleEditSuccess}
        />
      )}
    </>
  );
};
export default NewPhotos;
